import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";

export const getSettings = async (user: any, environment: string) => {
    try {
        if (!user) return;

        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/getSettings`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ environment: environment })
        });

        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.error(`Error checking if user is on paid sub: ${error}`);
        return {};
    }
}
